<template>
  <div>
    <!-- Priming: explain why, before the browser prompt appears. -->
    <bottom-sheet :open="state === 'priming'" persistent title="دسترسی به دوربین و میکروفون">
      <div class="sh-head">
        <div class="iconcircle"><base-icon name="camera" /></div>
        <div class="stack gap-10">
          <h2>دسترسی به دوربین و میکروفون</h2>
          <p>
            برای ثبت عکس چهره و ضبط ویدیوی همراه با صدا، به دوربین و میکروفون دستگاه شما نیاز
            داریم. در ادامه، مرورگر اجازه‌ی دسترسی را درخواست می‌کند؛ لطفاً «اجازه دادن» را
            انتخاب کنید.
          </p>
        </div>
      </div>
      <div class="sh-foot">
        <button class="btn btn-primary" type="button" :disabled="busy" @click="$emit('grant')">
          <base-icon name="camera" />
          <span>اجازه دسترسی به دوربین و میکروفون</span>
        </button>
      </div>
    </bottom-sheet>

    <!-- Blocked: the browser has already refused, so the fix is in its settings. -->
    <bottom-sheet :open="state === 'blocked'" persistent title="دسترسی بسته است">
      <div class="sh-head">
        <div class="iconcircle warn"><base-icon name="alert" /></div>
        <div class="stack gap-10">
          <h2>دسترسی بسته است</h2>
          <p>دسترسی دوربین و میکروفون را در مرورگر خود فعال کنید:</p>
        </div>
      </div>

      <ol class="steps">
        <li v-for="(step, index) in steps" :key="index">
          <span class="n">{{ toFa(index + 1) }}</span>
          <span class="t">
            <template v-for="(part, partIndex) in step">
              <span v-if="part.icon" :key="partIndex" class="mini"><base-icon name="lock" :width="2.2" /></span>
              <template v-else>{{ part.text }}</template>
            </template>
          </span>
        </li>
      </ol>

      <div class="sh-foot">
        <button class="btn btn-primary" type="button" :disabled="busy" @click="$emit('retry')">
          بررسی مجدد دسترسی
        </button>
      </div>
    </bottom-sheet>
  </div>
</template>

<script>
import BottomSheet from "./BottomSheet.vue";
import BaseIcon from "./BaseIcon.vue";
import { detectBrowser } from "@/utils/device";
import { toFa } from "@/utils/digits";

/**
 * Camera/microphone access, in the two states worth explaining.
 *
 * Both sheets are `persistent`: the flow physically cannot continue without access, so
 * neither may be dismissed by tapping outside. They close when access is granted.
 *
 * The "blocked" instructions are browser-specific and only the matching set is shown —
 * three alternative sets of steps is how you get a user to follow none of them.
 */
const STEPS = {
  chrome: [
    [{ text: "در نوار آدرس، روی نشان قفل " }, { icon: true }, { text: " بزنید." }],
    [{ text: "وارد بخش «مجوزها» شوید و «دوربین» و «میکروفون» را روی «اجازه» قرار دهید." }],
    [{ text: "صفحه را یک‌بار تازه کنید و سپس «بررسی مجدد دسترسی» را بزنید." }],
  ],
  safari: [
    [{ text: "در نوار آدرس، روی نشان «اَ آ / aA» بزنید و «تنظیمات وب‌سایت» را انتخاب کنید." }],
    [{ text: "گزینه‌های «دوربین» و «میکروفون» را روی «اجازه» قرار دهید." }],
    [
      {
        text:
          "اگر نبود، از «تنظیمات» گوشی → «Safari» → «دوربین» و «میکروفون» → «اجازه» را انتخاب کنید و بازگردید.",
      },
    ],
  ],
  samsung: [
    [{ text: "در نوار آدرس، روی نشان قفل " }, { icon: true }, { text: " بزنید." }],
    [{ text: "وارد «مجوزها» شوید و «دوربین» را روی «اجازه» قرار دهید." }],
    [{ text: "صفحه را تازه کنید و سپس «بررسی مجدد دسترسی» را بزنید." }],
  ],
};

export default {
  name: "PermissionGate",
  components: { BottomSheet, BaseIcon },

  props: {
    /** "closed" | "priming" | "blocked" */
    state: {
      type: String,
      default: "closed",
      validator: (value) => ["closed", "priming", "blocked"].indexOf(value) !== -1,
    },
    /** A request is in flight — keeps the user from double-prompting. */
    busy: { type: Boolean, default: false },
  },

  computed: {
    steps() {
      return STEPS[detectBrowser()] || STEPS.chrome;
    },
  },

  methods: { toFa },
};
</script>
